<nav class="nav fixed-top p-3 justify-content-center"
style="background-image: url('assets/img/h1_hero.png');
              background-repeat: no-repeat;
                background-attachment: fixed;
      background-position: center; 
       background-size: cover;
            "
            >
    <a class="nav-link" routerLink="/">Home</a>
    <a class="nav-link" routerLink="/aplikasi">Applikasi</a>
    <a class="nav-link" routerLink="/website">Website</a>
    <a class="nav-link" routerLink="/axcoraschool">ERP</a>
  </nav>

  <div class="container text-center">
    <img class="img-fluid" alt="erp sekolah online"
    src="assets/img/logo.png"/>
    <h1>Axcora school ERP PRO</h1>
      <img class="img-fluid" alt="erp sekolah online"
      src="assets/img/aplikasisekolah online web app (1).png"/>
      <p>
          Mohon maaf axcora school ERP Pro version masih dalam tahap pengembangan.
      </p>
      <p>
          Sedikit bocoran informasi applikasi ini sangat lah lengkap dalam kebutuhan untuk sekolah, berbagai aplikasi menjadi satu pada apps ini, untuk informasi lebih lanjut nantikan relase terbaru axcora school erp pro version .
      </p>
  </div>